import { validate } from 'services/api/sso';
import { checkFavoriteApplication } from 'App/contexts';

export default function handleRedirection(redirectUrl, fallbackUrl, onNoAccess) {
    // Fonction utilitaire pour gérer le fallback (avec une lazy evaluation)
    const handleFallback = () => (fallbackUrl ? checkFavoriteApplication(fallbackUrl) : onNoAccess?.());

    if (!redirectUrl) {
        // Pas d'URL de redirection, utiliser le fallback
        return handleFallback();
    }

    // Valider l'URL avant redirection
    return validate(redirectUrl)
        .then(() => {
            // URL valide (200), rediriger
            window.location.assign(redirectUrl);
        })
        .catch(() => {
            // URL invalide, utiliser le fallback
            return handleFallback();
        });
}
